var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveInvestment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-Thin-Swing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .inactiveInvestment1 {\r\n        fill: #e5e5e5;\r\n        opacity: 0;\r\n      }\r\n\r\n      .inactiveInvestment2, .inactiveInvestment3 {\r\n        fill: none;\r\n        stroke: #8c8d99;\r\n        stroke-linecap: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .inactiveInvestment3 {\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    className: "inactiveInvestment1",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "path",
    transform: "translate(-360 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    className: "inactiveInvestment2",
    d: "M365.256,260v16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    className: "inactiveInvestment2",
    d: "M362,272.78h20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    className: "inactiveInvestment3",
    d: "M379.181,263.24,373,269.42a1.007,1.007,0,0,1-1.414,0l-.839-.84a1.007,1.007,0,0,0-1.414,0l-1.9,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    className: "inactiveInvestment3",
    d: "M376.181,263.24h3v3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveInvestment);
export default __webpack_public_path__ + "static/media/inactive-investment.308c81f18e7f71542c1241a09e822283.svg";
export { ForwardRef as ReactComponent };